module.exports = __webpack_public_path__ + "4fe098a06933c749cd97f29492362bc0.jpg";